"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MissingTargetError = exports.InvalidEffectParamsError = exports.InvalidTargetError = void 0;
class InvalidTargetError extends Error {
    constructor(m) {
        super(m !== null && m !== void 0 ? m : 'Invalid target!');
    }
}
exports.InvalidTargetError = InvalidTargetError;
class InvalidEffectParamsError extends Error {
    constructor(m) {
        super(m !== null && m !== void 0 ? m : 'Invalid effect parameters!');
    }
}
exports.InvalidEffectParamsError = InvalidEffectParamsError;
class MissingTargetError extends Error {
    constructor(m) {
        super(m !== null && m !== void 0 ? m : 'Missing target!');
    }
}
exports.MissingTargetError = MissingTargetError;
